import { useRef, useEffect } from 'react';
import { Button } from "@mui/material";
import { imgPath } from './../App';

const MembersCard = ({ userData }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!userData) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = 360;
    canvas.height = 220;

    const bgImage = new Image();
    bgImage.src = `${imgPath}/images/bg-${userData.membership}-card.jpg`;

    const profileImg = new Image();
    profileImg.src = userData.img;

    // 両方の画像が読み込まれたら描画するようフラグ管理
    let bgLoaded = false;
    let profileLoaded = false;

    bgImage.onload = () => {
      bgLoaded = true;
      if (profileLoaded) drawCard();
    };

    profileImg.onload = () => {
      profileLoaded = true;
      if (bgLoaded) drawCard();
    };

    const drawCard = () => {
      // 背景
      ctx.drawImage(bgImage, 0, 0, canvas.width, canvas.height);

      // プロフィール画像（四角形で描画）
      ctx.drawImage(profileImg, 286, 15, 100 * .6, 110 * .6); // x, y, width, height

      ctx.fillStyle = "#fff";
      ctx.font = "16px 'Noto Sans JP', sans-serif";
      ctx.fillStyle = "#000";
      ctx.fillText(`No.`, 150, 32);

      ctx.font = "bold 19px 'Noto Sans JP'";
      ctx.fillText(`${userData.id}`, 180, 32);

      ctx.font = "bold 10px 'Noto Sans JP'";
      ctx.fillText(`Expiry Date`, 220, 58);

      ctx.font = "bold 12px 'Noto Sans JP'";
      ctx.fillStyle = userData.membership === `invalid` ? `#ff0033` : "#000";

      ctx.fillText(`${userData.expiry}`, 212, 76);

      ctx.fillStyle = "#000";

      const hasMiddleName = typeof userData.middleName === 'string' && userData.middleName.trim() !== '';
      ctx.font = `bold ${hasMiddleName ? "15px" : "24px"} 'Noto Sans JP'`;
      const name = hasMiddleName ? `${userData.familyName} ${userData.middleName} ${userData.firstName}` : `${userData.familyName} ${userData.firstName}`
      ctx.fillText(name, 90, 110);

      ctx.font = "bold 10px 'Noto Sans JP'";
      ctx.fillText(`Name`, 90, 128);

      const hasMiddleNameEn = typeof userData.middleNameEn === 'string' && userData.middleNameEn.trim() !== '';
      ctx.font = `bold ${hasMiddleNameEn ? "10px" : "12px"} 'Noto Sans JP'`;
      const nameEn = hasMiddleNameEn ? `${userData.firstNameEn} ${userData.middleNameEn} ${userData.familyNameEn}` : `${userData.firstNameEn} ${userData.familyNameEn}`
      ctx.fillText(`${nameEn}`, 125, 128);

      ctx.font = "bold 10px 'Noto Sans JP'";
      ctx.fillText(`Date of Birth`, 90, 150);

      ctx.font = "bold 12px 'Noto Sans JP'";
      ctx.fillText(`${userData.birthday}`, 160, 150);

      // ctx.beginPath();
      // ctx.moveTo(90, 117);
      // ctx.lineTo(360, 117);
      // ctx.strokeStyle = "#999";
      // ctx.lineWidth = 1;
      // ctx.stroke();
    };
  }, [userData]);

  const handleDownload = () => {
    const canvas = canvasRef.current;
    const imageData = canvas.toDataURL("image/jpeg", 0.9);
    const link = document.createElement("a");
    link.href = imageData;
    link.download = `${userData.id}-members-card.jpg`;
    link.click();
  };

  return (
    <div style={{ textAlign: "center" }}>
      <canvas
        ref={canvasRef}
        width={360}
        height={220}
        className='card'
        style={{ boxShadow: "0 0 15px rgb(0 0 0 / .3)" }}
      ></canvas>
      <p style={{ marginTop: "24px" }}>
        <Button
          onClick={handleDownload}
          style={{ background: `var(--blue)`, color: `#fff`, fontSize: `18px` }}
          sx={{ width: "250px" }}
        >
          ダウンロード
        </Button>
      </p>
    </div>
  );
};

export default MembersCard;
